"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Role;
(function (Role) {
    Role[Role["Seller"] = 0] = "Seller";
    Role[Role["Buyer"] = 1] = "Buyer";
})(Role = exports.Role || (exports.Role = {}));
var RoleString;
(function (RoleString) {
    RoleString["Seller"] = "Seller";
    RoleString["Buyer"] = "Buyer";
})(RoleString = exports.RoleString || (exports.RoleString = {}));
function getRoleString(role) {
    switch (role) {
        case Role.Buyer:
            return RoleString.Buyer;
        case Role.Seller:
            return RoleString.Seller;
        default:
            throw new Error("Unrecognized role \"" + role + "\"");
    }
}
exports.getRoleString = getRoleString;
function getRole(roleString) {
    switch (roleString) {
        case RoleString.Buyer:
            return Role.Buyer;
        case RoleString.Seller:
            return Role.Seller;
        default:
            throw new Error("Unrecognized role string \"" + roleString + "\"");
    }
}
exports.getRole = getRole;
//# sourceMappingURL=Role.js.map